import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailers-opt_in_nudges_view-view';

/**
 * Track successful view of the opt-in nudge surfaces. The &quot;Origin&quot; parameter below will return either &quot;POPUP_PROMPT&quot;, &quot;POST_ORDER_PRIMARY&quot;, &quot;POST_ORDER_SECONDARY&quot;, or &quot;FOOTER_PAGE&quot;
 */
export function trackRetailersOptInNudgesViewView(
  Origin_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Origin_string },
  });
}
